const mainContent = document.getElementById('MainContent');
const sections = mainContent?.querySelectorAll(':scope > .shopify-section');
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (sections?.length) {
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('editorial-reveal--visible'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('editorial-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6%', threshold: 0.12 }
    );

    sections.forEach((section) => {
      section.classList.add('editorial-reveal');

      // The first fold should be ready immediately, not wait for the observer callback.
      if (section.querySelector('.hero')) {
        section.classList.add('editorial-reveal--visible');
      } else {
        observer.observe(section);
      }
    });
  }
}
